export const SOL = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="16"
      cy="16"
      r="15.9765"
      fill="white"
      stroke="#CCD1DC"
      strokeWidth="0.0470588"
    />
    <g clipPath="url(#clip0_1_3216)">
      <path
        d="M9.67523 19.854C9.78817 19.7411 9.94346 19.6752 10.1082 19.6752H25.0446C25.3176 19.6752 25.454 20.0046 25.2611 20.1975L22.3105 23.1481C22.1976 23.2611 22.0423 23.3269 21.8776 23.3269H6.94111C6.66817 23.3269 6.5317 22.9975 6.72464 22.8046L9.67523 19.854Z"
        fill="url(#paint0_linear_1_3216)"
      />
      <path
        d="M9.67523 8.83751C9.79287 8.72457 9.94817 8.65869 10.1082 8.65869H25.0446C25.3176 8.65869 25.454 8.9881 25.2611 9.18104L22.3105 12.1316C22.1976 12.2446 22.0423 12.3105 21.8776 12.3105H6.94111C6.66817 12.3105 6.5317 11.981 6.72464 11.7881L9.67523 8.83751Z"
        fill="url(#paint1_linear_1_3216)"
      />
      <path
        d="M22.3105 14.3104C22.1976 14.1975 22.0423 14.1316 21.8776 14.1316H6.94111C6.66817 14.1316 6.5317 14.461 6.72464 14.6539L9.67523 17.6045C9.78817 17.7175 9.94346 17.7834 10.1082 17.7834H25.0446C25.3176 17.7834 25.454 17.4539 25.2611 17.261L22.3105 14.3104Z"
        fill="url(#paint2_linear_1_3216)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_3216"
        x1="23.6178"
        y1="6.8961"
        x2="13.2805"
        y2="26.696"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FFA3" />
        <stop offset="1" stopColor="#DC1FFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_3216"
        x1="19.0978"
        y1="4.53627"
        x2="8.76054"
        y2="24.3362"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FFA3" />
        <stop offset="1" stopColor="#DC1FFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_3216"
        x1="21.3434"
        y1="5.70863"
        x2="11.0062"
        y2="25.5086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FFA3" />
        <stop offset="1" stopColor="#DC1FFF" />
      </linearGradient>
      <clipPath id="clip0_1_3216">
        <rect
          width="18.7153"
          height="14.6682"
          fill="white"
          transform="translate(6.63525 8.65881)"
        />
      </clipPath>
    </defs>
  </svg>
);
